import { render } from "./TokenType.vue?vue&type=template&id=887a687c"
import script from "./TokenType.vue?vue&type=script&lang=js"
export * from "./TokenType.vue?vue&type=script&lang=js"

import "./TokenType.vue?vue&type=style&index=0&id=887a687c&lang=scss"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__